import Base from './base'

export default {
  get () {
    return Base
      .get('/webinvoicenumbers/next')
      .then(res => res.data)
  }
}
